export const formatDate = (date) => {
    if (date) {
        const dateValue = new Date(date);
        const y = dateValue.getFullYear();
        const m = dateValue.getMonth() + 1;
        const d = dateValue.getDate();
        return `${y}-${m <= 9 ? "0" + m : m}-${d <= 9 ? "0" + d : d}`;
    }
    return null;
};

export const checkDateMonth = (from, to, range) => {
    const valueFromDate = new Date(from);
    const valueAfterDate = new Date(valueFromDate.setMonth(valueFromDate.getMonth() + range));
    const valueToDate = new Date(to);
    return Math.floor(valueToDate.getTime() / 24 / 60 / 60 / 1000) <= Math.floor(valueAfterDate.getTime() / 24 / 60 / 60 / 1000);
};

export const checkDateDay = (from, to, range) => {
    const valueFromDate = new Date(from);
    const valueAfterDate = new Date(valueFromDate.setDate(valueFromDate.getDate() + range));
    const valueToDate = new Date(to);
    return Math.floor(valueToDate.getTime() / 24 / 60 / 60 / 1000) <= Math.floor(valueAfterDate.getTime() / 24 / 60 / 60 / 1000);
};

export const range1 = 5;
export const range2 = 3;

export const dateFormat1 = "dd/mm/yy";
export const dateFormat2 = "ddmmyy";
